import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import Button from '@mui/material/Button'

const useStyles = makeStyles((theme) => ({
  hoverButtton: {
    border: '2px solid #2B1C2F',
    boxSizing: 'border-box',
    boxShadow: '0px 2px 0px #2B1C2F',
    borderRadius: '8px',
    backgroundSize: '100% auto',
    fontSize: '12px',
    lineHeight: '18px',
    padding: '6px 3px',
    fontWeight: 800,
    textTransform: 'uppercase',
    fontFamily: "'Dosis', sans-serif",
    '&:hover': {
      boxShadow: '0px 2px 0px #2B1C2F',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '20px',
      lineHeight: '26px',
      padding: theme.spacing(1.5, 1),
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '24px',
      lineHeight: '30px',
      padding: theme.spacing(1.5, 2),
    },
  },
}))

const HoverButtton = (props) => {
  const classes = useStyles()
  const { ...other } = props
  //  textSize, textColor, textBorder, textBorderSize,
  const colorCode = '#FF8FC1'

  return (
    <Button variant="contained" style={{ backgroundColor: colorCode }} className={classes.hoverButtton} {...other} />
  )
}
export default HoverButtton
